
var ReactNative = require('react-native');
var {
  Linking,
} = ReactNative;

module.exports = {
  getLaunchedURL : function(completion)
  {
    var url = Linking.getInitialURL().then((url) =>
    {
      if( completion ) completion(url);
    }).catch(err => console.error('An error occurred', err));
  },
  addEventListener : function(responder)
  {
    Linking.addEventListener('url', responder);
  },
  removeEventListener : function(responder) {
    if( typeof responder !== 'function' ) return;
    try
    {
      Linking.removeEventListener('url', responder);
    }
    catch (e)
    {
      // no listener was registered for 'url' - nothing to remove
    }
  }
}
